export default "__VITE_ASSET__452159e8__"